webpackJsonp([23],{

/***/ "CTLc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__("TToO");
var RescaleSvc_1 = __webpack_require__("7T+Z");
var underscore_extensions_1 = __webpack_require__("R0iF");
var WistiaPlayer = (function () {
    WistiaPlayer.$inject = ["$element", "$rootScope", "wistiaSvc", "stopPlaySvcFactory"];
    function WistiaPlayer($element, $rootScope, wistiaSvc, stopPlaySvcFactory) {
        var _this = this;
        this.$element = $element;
        this.$rootScope = $rootScope;
        this.wistiaSvc = wistiaSvc;
        this.stopPlaySvcFactory = stopPlaySvcFactory;
        this.showPreview = true;
        this.wistiaId = options.handHeld && this.video.mobileWistiaId ? this.video.mobileWistiaId : this.video.wistiaId;
        this.onModalClose = this.onModalClose || _.noop;
        this.onReady = this.onReady || _.noop;
        this.calcTime = underscore_extensions_1.Utils.calcTime;
        this.modalShowListener = _.noop;
        this.defaultOptions = {
            autoPlay: false
        };
        this.fullscreenChange = function () {
            var fullscreenElement = document.fullscreenElement || document.mozFullScreenElement ||
                document.webkitFullscreenElement || document.msFullscreenElement;
            if (fullscreenElement != null) {
                _this.wistiaPlayer.play();
                _this.wistiaPlayer.volume(100);
            }
            else {
                _this.wistiaPlayer.volume(_this.options.volume);
            }
        };
        if (options.handHeld) {
            this.isPlayBtn = false;
            this.inModal = false;
        }
        this.canPlay = !this.isPlayBtn && (this.video.isMobile || !options.handHeld);
        this.options = tslib_1.__assign({}, this.defaultOptions, this.options);
        this.setWistiaMedia();
        this.stopPlaySvc = this.stopPlaySvcFactory(this.$element, function (isPlaying) {
            _this.isVideoPlaying = isPlaying;
            _this.playVideo();
        }, this.video.scrollCentredOn);
        if (this.canPlay) {
            this.loadVideo();
        }
    }
    WistiaPlayer.prototype.$onDestroy = function () {
        this.wistiaPlayer && this.wistiaPlayer.unbind('heightchange', this.fullscreenChange);
        this.stopPlaySvc && this.stopPlaySvc.deactivate();
    };
    WistiaPlayer.prototype.$onChanges = function (onChangesObj) {
        var isUpdated = function (obj) { return obj && obj.previousValue !== obj.currentValue; };
        this.canOpenModal = this.inModal && this.canPlay;
        if (this.wistiaPlayer && isUpdated(onChangesObj.time)) {
            this.wistiaPlayer.time(this.time);
        }
    };
    WistiaPlayer.prototype.loadVideo = function () {
        this.canPlay = this.video.isMobile || !options.handHeld;
        if (!this.canPlay)
            return;
        if (this.inModal) {
            this.playInModal();
        }
        else {
            this.playInside();
        }
    };
    WistiaPlayer.prototype.playInModal = function () {
        var el;
        this.modalShowListener = this.$rootScope.$on('modal:show', function () {
            el = document.querySelector('.modal-wistia-player');
            el.style.opacity = '0';
        });
        this.canOpenModal = true;
        this.getPlayer().then(function (videoPlayer) {
            var maxWidth = (window.innerWidth / 1.4);
            var maxHeight = (window.innerHeight / 1.2);
            var _a = RescaleSvc_1.RescaleSvc.resizeWithAspectRatio(videoPlayer.width(), videoPlayer.height(), maxWidth, maxHeight, true, true), width = _a.width, height = _a.height;
            var modalPadding = 20;
            videoPlayer.width(width - modalPadding);
            videoPlayer.height(height - modalPadding);
            Object.assign(el.style, {
                width: width + "px",
                height: height + "px",
                opacity: '1'
            });
        });
    };
    WistiaPlayer.prototype.playInside = function () {
        var _this = this;
        this.getPlayer().then(function () {
            _this.playVideo();
        });
    };
    WistiaPlayer.prototype.modalCloseHandler = function () {
        this.canOpenModal = false;
        this.showPreview = true;
        this.onModalClose();
        this.modalShowListener();
    };
    WistiaPlayer.prototype.setWistiaMedia = function () {
        var _this = this;
        this.wistiaSvc.getMedia(this.wistiaId).then(function (media) {
            _this.video.preview = _this.video.preview || media.thumbnail.url;
            _this.video.duration = _this.calcTime(media.duration);
        });
    };
    WistiaPlayer.prototype.getPlayer = function () {
        var _this = this;
        return this.wistiaSvc.getWistiaPlayer(this.wistiaId, this.options)
            .then(function (videoPlayer) {
            _this.wistiaPlayer = videoPlayer;
            _this.wistiaPlayer.bind('heightchange', _this.fullscreenChange);
            _this.onReady({ video: _this.wistiaPlayer });
            return videoPlayer;
        });
    };
    WistiaPlayer.prototype.playVideo = function () {
        if (this.wistiaPlayer) {
            // fix bug with incorrect height in wistia player
            if (!this.inModal) {
                var width = Math.floor(this.$element[0].getBoundingClientRect().width);
                this.wistiaPlayer.width(width, { constrain: true });
            }
            var canPlay = this.inModal || this.isVideoPlaying;
            if (canPlay) {
                this.wistiaPlayer.play();
                this.showPreview = this.inModal;
            }
            else {
                this.wistiaPlayer.pause();
            }
            if (this.isVideoPlaying && this.time && this.time > 0) {
                this.wistiaPlayer.time(this.time);
                this.wistiaPlayer.play();
            }
        }
    };
    return WistiaPlayer;
}());
exports.WistiaPlayer = WistiaPlayer;
angular.module('animatronApp.wistiaPlayer', []).component('wistiaPlayer', {
    bindings: {
        onModalClose: '&?',
        onReady: '&?',
        inModal: '<',
        video: '<',
        time: '<?',
        isPlayBtn: '<?',
        isDuration: '<?',
        options: '<?'
    },
    controller: WistiaPlayer,
    templateUrl: __webpack_require__("ze4q")
});


/***/ }),

/***/ "ze4q":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/wistia-player_507bd1b56b94946825e085bf0256658b.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/23-257c10c0995a4d25fa59.min.js